import { TranslationService } from '../../../../../../services/translation.service';
import { ITransportWarrantyActualArrivalSelectorStateValue } from '../..';
import { ReplacementTransportMode } from '../ReplacementTransport/replacement-transport-mode.enum';
import { CurrencyHelper } from '../../../../../../helpers/currency.helper';

function TransportWarrantyActualTripSelectorSummary({ stateValue, onEditClick }: { stateValue: ITransportWarrantyActualArrivalSelectorStateValue; onEditClick?: () => void }) {
  return (
    <div className="delay-compensation-form__actual-arrival-selector-summary p-2 rounded border">
      <div>
        <div>
          <span className="fw-bold p-1">{TranslationService.get('delaycompensatiotransportwarrantyformpage.reasonforalternativetransport')}:&nbsp;</span>
          <div className="p-1">{stateValue.comments}</div>
        </div>
        <table className="table table-borderless table-sm">
          <tbody>
            <tr>
              <th scope="row">{TranslationService.get('delaycompensatiotransportwarrantyformpage.transport')}:&nbsp;</th>
              <td className="w-100">{TranslationService.get(`delaycompensatiotransportwarrantyformpage.transportmode${stateValue.transportMode.toLocaleLowerCase()}`)}</td>
            </tr>

            {stateValue.transportMode === ReplacementTransportMode.taxi && (
              <>
                <tr>
                  <th scope="row">{TranslationService.get('common.from')}:&nbsp;</th>
                  <td>{stateValue.from}</td>
                </tr>
                <tr>
                  <th scope="row">{TranslationService.get('common.to')}:&nbsp;</th>
                  <td>{stateValue.to}</td>
                </tr>
                <tr>
                  <th scope="row">{TranslationService.get('delaycompensatiotransportwarrantyformpage.cost')}:&nbsp;</th>
                  <td>{CurrencyHelper.toLocaleStringWithZeroOrTwoDigits(stateValue.taxiSum)}</td>
                </tr>
              </>
            )}
            {stateValue.transportMode === ReplacementTransportMode.ownCar && (
              <>
                <tr>
                  <th scope="row">{TranslationService.get('common.from')}:&nbsp;</th>
                  <td>{stateValue.from}</td>
                </tr>
                <tr>
                  <th scope="row">{TranslationService.get('common.to')}:&nbsp;</th>
                  <td>{stateValue.to}</td>
                </tr>
                <tr>
                  <th scope="row">{TranslationService.get('delaycompensatiotransportwarrantyformpage.registrationnumber')}:&nbsp;</th>
                  <td>{stateValue.registrationNumber}</td>
                </tr>
                <tr>
                  <th scope="row">{TranslationService.get('delaycompensatiotransportwarrantyformpage.drivingdistance')}:&nbsp;</th>
                  <td>{stateValue.distance} km</td>
                </tr>
                {stateValue.parkingFee && (
                  <tr>
                    <th scope="row">{TranslationService.get('delaycompensatiotransportwarrantyformpage.parkingfee')}:&nbsp;</th>
                    <td>{CurrencyHelper.toLocaleStringWithZeroOrTwoDigits(stateValue.parkingFee)}</td>
                  </tr>
                )}
                {stateValue.congestionTax && (
                  <tr>
                    <th scope="row">{TranslationService.get('delaycompensatiotransportwarrantyformpage.congestiontax')}:&nbsp;</th>
                    <td>{CurrencyHelper.toLocaleStringWithZeroOrTwoDigits(stateValue.congestionTax)}</td>
                  </tr>
                )}
              </>
            )}
            {stateValue.transportMode === ReplacementTransportMode.other && (
              <>
                <tr>
                  <th scope="row">{TranslationService.get('delaycompensatiotransportwarrantyformpage.meansoftransport')}:&nbsp;</th>
                  <td>{stateValue.otherTransportType}</td>
                </tr>
                <tr>
                  <th scope="row">{TranslationService.get('delaycompensatiotransportwarrantyformpage.cost')}:&nbsp;</th>
                  <td>{CurrencyHelper.toLocaleStringWithZeroOrTwoDigits(stateValue.receiptSum)}</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
        {stateValue.files.length > 0 && (
          <div className="mb-3">
            <span className="fw-bold">{TranslationService.get('delaycompensatiotransportwarrantyformpage.attachedfiles')}:</span>
            <ul className="list-unstyled">
              {stateValue.files.map((file) => (
                <li key={file.name}>{file.name}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div className="text-end">
        <button className="btn btn-tertiary btn-icon-left btn-icon-pen" onClick={onEditClick}>
          {TranslationService.get('common.edit')}
        </button>
      </div>
    </div>
  );
}

export default TransportWarrantyActualTripSelectorSummary;
